import { Lang } from 'Roblox';
import angular from 'angular';

let notificationStream = angular
    .module("notificationStream", ["robloxApp", "ui.bootstrap", "notificationStreamHtmlTemplate"])
    .config(['languageResourceProvider',
        function (languageResourceProvider) {
            if (Lang.NotificationStreamResources) {
                languageResourceProvider.setLanguageKeysFromFile(Lang.NotificationStreamResources);
            }
        }
    ]);


export default notificationStream;